<template>
  <div class="visible lg:invisible block lg:hidden" v-if="$store.state[$store.state.view + 'Module'].client != null">

    <div class="py-2 px-4 bg-gray-100">
      <select class="select-standard" v-model="route" v-on:change="pathChanged">
        
        <template v-for="(applicant, index) in $store.state[$store.state.view + 'Module'].client.applicants">
          <option :value="'application-applicant-profile-' + applicant.id">Applicant - {{ getApplicantName(applicant) }}</option>
        </template>

        <option value="application-requirement">Requirements</option>
        <option value="application-asset">Assets</option>
        <option value="application-liability">Liabilities</option>
        <option value="application-expense">Living Expenses</option>
        <option value="application-risk-profile">Risk Profile</option>

        <template v-for="(applicant, index) in $store.state[$store.state.view + 'Module'].client.applicants">
          <option :value="'application-document-' + applicant.id">Document - {{ getApplicantName(applicant) }}</option>
        </template>

        <template v-if="$store.state.view == 'broker'">
          <option value="application-submit-broker">Submit</option>
        </template>

        <template v-else>
          <option value="application-submit-client">Submit</option>
        </template>
      </select>
    </div>

  </div>
</template>

<script>
  // import ApplicantNavigation  from './ApplicantNavigation'

  export default {

    data() {
      return {
        route : this.$route.name
      }
    },

    created() {
      if(this.$route.name == 'application-document' || this.$route.name == 'application-applicant-profile') {
        this.route = this.$route.name + '-' + this.$route.params.applicantId
      }
    },

    methods : {
      pathChanged() {

        if(this.route.indexOf('application-document') > -1) {
          let arr = this.route.split("-")

          this.$router.push({ 
            name  : 'application-document',
            params: {
              clientId   : this.$route.params.clientId,
              applicantId: arr[2]
            }
          })
        }

        else if(this.route.indexOf('application-applicant-profile') > -1) {
          let arr = this.route.split("-")

          this.$router.push({ 
            name  : 'application-applicant-profile',
            params: {
              clientId   : this.$route.params.clientId,
              applicantId: arr[3]
            }
          })
        }

        else {
          this.$router.push({ 
            name  : this.route,
            params: {
              clientId : this.$route.params.clientId
            }
          })
        }
      }
    }

  //   components : {
  //     ApplicantNavigation
  //   },

  //   methods : {
  //     addApplicant(type) {
  //       this.showLoader("Adding an applicant...")
  //       this.apiPost({
  //         clientId: this.$route.params.clientId,
  //         type          
  //       }, 'applicant/create', (applicant) => {

  //         this.getClient({
  //           force   : true,
  //           clientId: this.$route.params.clientId
  //         }, (client) => {
  //           this.hideLoader()
  //           this.client = client

  //           // once this is set, we can take the user to newly added applicant page
  //           this.$router.push({ 
  //             name  : 'application-applicant-profile',
  //             params: {
  //               clientId   : this.$route.params.clientId,
  //               applicantId: applicant.id
  //             }
  //           })
  //         })
  //       })
  //     },
  //   }
  }
</script>